export const useExpandableText = (
  el: Ref<HTMLElement | null>,
  isExpanded: Ref<boolean>,
  text: Ref<string>,
) => {
  const isOverflowing: Ref<boolean> = ref(false);
  let frame: number | null = null;
  let resizeObserver: ResizeObserver | null = null;

  const readOverflow = (): void => {
    if (isExpanded.value) {
      isOverflowing.value = false;
      return;
    }
    const node = el.value;
    isOverflowing.value = node ? node.scrollHeight > node.clientHeight : false;
  };

  const measure = (): void => {
    if (frame !== null) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      frame = null;
      readOverflow();
    });
  };

  onMounted(() => {
    if (!el.value) return;
    resizeObserver = new ResizeObserver(readOverflow);
    resizeObserver.observe(el.value);
  });

  onBeforeUnmount(() => {
    resizeObserver?.disconnect();
    if (frame !== null) cancelAnimationFrame(frame);
  });

  watch(text, measure);

  return { isOverflowing };
};

export default useExpandableText;
